module.exports = __webpack_public_path__ + "img/work-env.6a42f072.jpg";